import type { FC } from 'react';

import Pill from '@/common-components/Pill';
import type { CampusStatus } from '@/types/campus.types';

const STATUS_CONFIG: Record<CampusStatus, { tone: 'success' | 'warn'; label: string }> = {
  active: { tone: 'success', label: 'Active' },
  paused: { tone: 'warn', label: 'Paused' },
};

const CampusStatusPill: FC<{ status: CampusStatus }> = ({ status }) => {
  const { tone, label } = STATUS_CONFIG[status];
  return <Pill tone={tone}>{label}</Pill>;
};

export default CampusStatusPill;
